import { changeTheme, updateCustomColor } from '@/scripts/colorTheme.js';


export default {
    state: {
        isBlackTheme: false,
        mainColor: '',
        customColor: {
            MAIN: {
                red: 0,
                green: 0,
                blue: 0,
            },
            MAIN_2UP: {
                red: 0,
                green: 0,
                blue: 0,
            },
            MAIN_4UP: {
                red: 0,
                green: 0,
                blue: 0,
            },
            MAIN_2DOWN: {
                red: 0,
                green: 0,
                blue: 0,
            },
            MAIN_4DOWN: {
                red: 0,
                green: 0,
                blue: 0,
            }
        },
    },
    getters: {
        IS_BLACK_THEME: state => { return state.isBlackTheme },
        MAIN_COLOR: state => { return state.mainColor },
        CUSTOM_COLOR: state => { return state.customColor },
    },
    mutations: {
        IS_BLACK_THEME: (state, payload) => { state.isBlackTheme = payload },
        MAIN_COLOR: (state, payload) => { state.mainColor = payload },
        CUSTOM_COLOR_UPDATE: (state, { value, color }) => {
            const newColor = [
                Math.round(value),
                Math.round(value * 1.2),
                Math.round(value * 1.4),
                Math.round(value * 0.8),
                Math.round(value * 0.6),
            ];

            let index = 0;
            for (let objName in state.customColor) {
                const obj = state.customColor[objName];
                obj[color] = newColor[index];
                index += 1;
            }
        },
    },
    actions: {
        CHANGE_CUSTOM_COLOR: async function (context, { color, value }) {
            context.commit('CUSTOM_COLOR_UPDATE', {
                value: value,
                color: color
            });
            context.dispatch('SAVE_LOCAL_STORAGE');

            const customColor = context.getters.CUSTOM_COLOR;
            for (const [key, value] of Object.entries(customColor)) {
                const newColor = `rgb(${value['red']},${value['green']},${value['blue']})`;
                await updateCustomColor(key, newColor);
            }

            await context.dispatch('CHANGE_THEME');
        },
        CHANGE_ALL_CUSTOM_COLOR: async function (context, { red, green, blue, isLoad = false }) {
            context.commit('CUSTOM_COLOR_UPDATE', { value: red, color: 'red' });
            context.commit('CUSTOM_COLOR_UPDATE', { value: green, color: 'green' });
            context.commit('CUSTOM_COLOR_UPDATE', { value: blue, color: 'blue' });
            if (!isLoad) context.dispatch('SAVE_LOCAL_STORAGE');

            const customColor = context.getters.CUSTOM_COLOR;
            for (const [key, value] of Object.entries(customColor)) {
                const newColor = `rgb(${value['red']},${value['green']},${value['blue']})`;
                updateCustomColor(key, newColor);
            }

            if (!isLoad) await context.dispatch('CHANGE_THEME');
        },
        CHANGE_THEME: async function (context) {
            const isBlackTheme = context.getters.IS_BLACK_THEME;
            const mainColor = context.getters.MAIN_COLOR;

            await changeTheme(isBlackTheme, mainColor);
        }
    }
}